import { render, staticRenderFns } from "./RelatedLinksMgmt.vue?vue&type=template&id=0341eada&scoped=true&"
import script from "./RelatedLinksMgmt.vue?vue&type=script&lang=js&"
export * from "./RelatedLinksMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341eada",
  null
  
)

export default component.exports